export default __webpack_public_path__ + "static/media/icon_1_1.ef261930.svg";